// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_li-1";
export var rowFirst = "_li-3";
export var rowLast = "_li-5";
export var rowMiddle = "_li-4";
export var ticketListScroll = "_li-2";
export var ticketStack = "_li-0";